import React from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import CreatePrivateDiscountCodeForm from "../../Forms/CreatePrivateDiscountCodeForm/CreatePrivateDiscountCodeForm";

const CreatePrivateDiscountCodeContainer = () => {
  return (
    <div className="w-100">
      <TableFixedPage title={"ایجاد کد تخفیف شخصی"} />
      <CreatePrivateDiscountCodeForm />
    </div>
  );
};

export default CreatePrivateDiscountCodeContainer;
